import { Result, ok, err } from "neverthrow";
import { ParseError } from "../../shared/errors/parseError";
import {
  HttpVoc,
  HttpVocListResponse,
  IVocCollectionParser,
} from "../bbsRepository.types";
import { IVoc, IVocCollection } from "@/domain/entities/bbs";
import dayjs from "dayjs";
import { injectable } from "inversify";

function parseVoc(data: HttpVoc): IVoc {
  const voc = {
    uid: data.uid,
    serviceUid: data.serviceUid,
    title: data.title,
    writerUid: data.createdUid,
    vocTypeCode: data.vocTypeCode,
    vocTypeName: data.vocTypeName,
    displayYn: data.displayYn,
    secretYn: data.secretYn,
    statusCode: data.statusCode,
    statusName: data.statusName,
    statusTs: data.statusTs,
    updatedTs: dayjs(data.updatedTs).format("YYYY-MM-DD HH:mm"),
    createdTs: dayjs(data.createdTs).format("YYYY-MM-DD HH:mm"),
    savedTs: dayjs(data.savedTs).format("YYYY-MM-DD HH:mm"),
  };
  return voc;
}

@injectable()
export class VocCollectionParser implements IVocCollectionParser {
  constructor() {}

  toDomain(response: HttpVocListResponse): Result<IVocCollection, ParseError> {
    try {
      const totalCount = response.totalCount;
      const voc = response.data.map(parseVoc);
      const vocCollection: IVocCollection = {
        list: voc,
        totalCount: totalCount ?? 0,
      };
      return ok(vocCollection);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
